import React, { useState, useEffect } from 'react';
import axios from 'axios';
import FormComponent from '../../../Reusable_Components/FormComponent';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/Config/apiConfig';
import { useParams } from 'react-router-dom';

const CustomerInteractionInput = () => {
  const [formData, setFormData] = useState({});
  const [isEditing, setIsEditing] = useState(false);
  const route = 'customerInteraction';
  const { interactionId = '' } = useParams();
  const decodedId = interactionId ? atob(interactionId) : interactionId;
  const id = decodedId.replace(/\D/g, '');

  useEffect(() => {
    if (interactionId) {
      setIsEditing(true);
      fetchInteractionDetails();
    }
  }, [interactionId]); // eslint-disable-line react-hooks/exhaustive-deps

  const fetchInteractionDetails = async () => {
    try {
      const response = await axios.get(`${API_DOMAIN}${API_ROUTES.customerInteraction}${id}/`, { headers });
      setFormData(response.data);
    } catch (error) {
      console.error('Error fetching interaction details:', error);
    }
  };

  const interactionFields = [
    {
      name: 'customer', label: 'Customer', type: 'async-select',
      endpoint: API_ROUTES.customer,
      getOptionLabel: (c) => c.name,
    },
    { name: 'date', label: 'Date', type: 'date', dateConstraint: 'past' },
    {
      name: 'interaction_type', label: 'Interaction Type', type: 'select',
      options: [
        { value: 'call', label: 'Call' },
        { value: 'email', label: 'Email' },
        { value: 'meeting', label: 'Meeting' },
        { value: 'chat', label: 'Chat' },
        { value: 'in_person', label: 'In-Person' },
        { value: 'other', label: 'Other' },
      ],
    },
    {
      name: 'outcome', label: 'Outcome', type: 'select',
      options: [
        { value: '', label: '— Select Outcome —' },
        { value: 'positive', label: 'Positive' },
        { value: 'neutral', label: 'Neutral' },
        { value: 'negative', label: 'Negative' },
        { value: 'pending', label: 'Pending' },
      ],
    },
    {
      name: 'handler', label: 'Handler', type: 'async-select',
      endpoint: API_ROUTES.users,
      getOptionLabel: (h) => h.username,
    },
    { name: 'notes', label: 'Notes', type: 'textarea' },
  ];

  return (
    <div>
      <h1>{isEditing ? 'Edit Customer Interaction' : 'Create Customer Interaction'}</h1>
      <FormComponent fields={interactionFields} initialFormData={formData} route={route} cancelPath="/customer/interactions/list" />
    </div>
  );
};

export default CustomerInteractionInput;
